import React, { useEffect } from "react";
import {
  Drawer,
  Box,
  IconButton,
  Divider,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { X } from "lucide-react";

const ReuseSidebar = ({
  isOpen,
  onClose,
  title,
  children,
  selectedProduct,
  button,
  width = 400,
  variant = "persistent", // temporary | persistent | permanent
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const drawerWidth = isMobile ? "100vw" : width;

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);
  const drawerContent = (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          backgroundColor: "grey.50",
          borderBottom: 1,
          borderColor: "divider",
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <p className=" font-semibold text-xl">
              {title}
              <span className=" text-gray-400 shadow-sm border-b-2 border-gray-400 px-2 py-0.5 rounded-md ms-2 text-sm font-medium bg-gray-200">
                {button}
              </span>
            </p>
          </Box>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              "&:hover": {
                backgroundColor: "grey.200",
              },
            }}
          >
            <X size={20} />
          </IconButton>
        </Box>
      </Paper>

      <Divider />

      {/* Content Area */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          p: 2,
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "grey.100",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "grey.400",
            borderRadius: "3px",
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      variant={variant}
      sx={{
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          maxWidth: "100vw",
          boxSizing: "border-box",
          boxShadow: theme.shadows[8],
        },
      }}
      ModalProps={{
        keepMounted: true,
        ...(variant === "temporary" && {
          BackdropProps: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.3)",
            },
          },
        }),
      }}
      // Slide transition
      transitionDuration={{
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
      }}
    >
      {drawerContent}
    </Drawer>
  );
};

export default ReuseSidebar;
